import { Button } from "@volca/ui/components/ui/button";
import {
  PageContainer,
  PageTitle,
} from "@volca/ui/components/ui/page-components";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { toast } from "@volca/ui/lib/toast";
import { openSupportChatWithMessage } from "@/core/pylon";
import { ProfitabilityReportPreview } from "./profitability-report-preview";

const ACCESS_MESSAGE =
  "Hi! I am interested in job costing reports. Can you help enable them for our account?";

const benefits = [
  {
    title: "Choose your reporting period",
    description:
      "Run a report for a week, a month, or any date range you need.",
  },
  {
    title: "Review and share the details",
    description:
      "Open the detailed workbook or download a copy to review with your team.",
  },
  {
    title: "Get answers about your results",
    description:
      "Ask questions about a report or compare it with a previous period.",
  },
  {
    title: "Build reports with a click",
    description:
      "Choose your dates and click Run report. Volca puts the numbers together for you.",
  },
];

export const ProfitabilityPreview = () => {
  const requestAccess = () => {
    if (!openSupportChatWithMessage(ACCESS_MESSAGE)) {
      toast.error(
        "Chat could not open. Please refresh the page and try again.",
      );
    }
  };

  return (
    <section
      aria-labelledby="profitability-preview-title"
      className="min-h-full text-ink"
    >
      <PageContainer className="max-w-6xl pt-12 md:pt-20">
        <div className="grid w-full items-start gap-10 lg:grid-cols-2 lg:gap-14">
          <Stack align="start" gap={8}>
            <Stack align="start" gap={5}>
              <PageTitle id="profitability-preview-title">
                See what you earn. Know what you keep.
              </PageTitle>
              <Text tone="muted" className="max-w-prose text-pretty">
                Revenue, costs, and profit in one report. Choose your dates,
                review the numbers, and ask questions about the result.
              </Text>
              <Stack align="start" gap={2}>
                <Button size="lg" onClick={requestAccess}>
                  Get job costing reports
                </Button>
                <Text tone="muted" className="max-w-xs">
                  Talk with our team about setup for your business.
                </Text>
              </Stack>
            </Stack>
            <ul className="grid gap-5">
              {benefits.map(({ title, description }) => (
                <li key={title}>
                  <Text variant="label">{title}</Text>
                  <Text
                    tone="muted"
                    className="mt-1 leading-relaxed text-pretty"
                  >
                    {description}
                  </Text>
                </li>
              ))}
            </ul>
          </Stack>
          <ProfitabilityReportPreview />
        </div>
      </PageContainer>
    </section>
  );
};
